/*
**  @desc:    推广位统计
**  @author:  yikuang@sohu-inc.com
**  @date:    2017-06-20
*/

import Exposure from '../utils/exposure';
import SohuStat from './sohu-stat';
import Helper from '../utils/helper';

var PromEvStat = (function() {
    var exposure = new Exposure();
    var promList;

    function init(promList) {
        promList = promList || document.querySelectorAll('a[data-promo="true"]')
        addExpose(promList);
        exposure.allExposureCheck();
        exposure.addListener();
    }

    function addExpose(promList) {
        var length = promList.length;
        for(var i=0; i<length; i++) {
            (function(i) {
                var dom = promList[i];
                var paramsObj = Helper.urlToObj(dom.getAttribute('href'));
                exposure.add({
                    dom: dom,
                    callback: function() {
                        SohuStat.sendStatistics('prom_ev', {
                            posId: paramsObj.posId,
                            itemId: paramsObj.itemId
                        });
                    }
                });
            })(i);
        }
    }

    return {
        init: init,
        addExpose: addExpose
    };
})();

export default PromEvStat;